module.exports = __webpack_public_path__ + "static/media/fin-graph.84ed203e.jpg";